import { useMutation, useQueryClient } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import type { CreateCountryRequest } from '../types/countries.types';
import { COUNTRY_HIERARCHY_INPUT_KEY, COUNTRY_HIERARCHY_MULTI_SELECT_KEY, countryKeys } from './queryKeys';
import { regionKeys } from '@/features/regions/hooks/queryKeys';

export const useCreateCountry = () => {
  const queryClient = useQueryClient();

  const createCountry = useMutation({
    mutationFn: (data: CreateCountryRequest) => countriesApi.createCountry(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: countryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: countryKeys.territories() });
      queryClient.invalidateQueries({ queryKey: countryKeys.hierarchy() });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_INPUT_KEY] });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_MULTI_SELECT_KEY] });
      queryClient.invalidateQueries({ queryKey: regionKeys.lists(), refetchType: 'all' });
    },
  });

  return {
    createCountry: createCountry.mutate,
    isCreating: createCountry.isPending,
    isSuccess: createCountry.isSuccess,
  };
};
